import React, { useEffect } from 'react';
import notifCSS from './Notification.module.css'
import { useSelector, useDispatch } from 'react-redux';
import { resetNotification } from '../../redux/actions/NotificationActions';

//Used in App.js
//in the BackOfficeContentWrapper component.
function Notification() {

    const notification = useSelector((state) => state.notification);
    const auth = useSelector((state) => state.auth);
    const dispatch = useDispatch();

    useEffect(() => {

        //Clears the timeout when a new notification
        //comes in so that notification can be shown for 
        //the full three seconds

        //clearTimeout(triggerResetNotifState());

        //restarts the timer

        //triggerResetNotifState();

    }, [notification.customer_name]);


    const triggerResetNotifState = () => {
         
        return setTimeout(() => {
            dispatch(resetNotification());
        }, 3000);
    } 
    

    return (
        <div>
            {notification.customer_name === '' && auth ? <div></div> :
                <div className={notifCSS.notbox}>
                    {/* <button onClick={(e) => {e.preventDefault(); dispatch(resetNotification())}} className={notifCSS.button}> */}
                    <button className={notifCSS.button}>
                    </button>
                    <div className={notifCSS.container}>
                        <p>{`Received new order from ${notification.customer_name}!`}</p>
                    </div>
                </div>}
        </div>
    )
}

export default Notification;